module.exports = __webpack_public_path__ + "static/img/categorias.a584b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categorias.png
// module id = 0/UF
// module chunks = 1